import { FormEvent } from 'react'
import { useParams } from 'react-router'
import { useDocumentGet, useDocumentUpdate } from '../api/documents'
import { ReservationDocumentForm } from './reservation-document-form'

export function ReservationDocumentEdit() {
	const { id } = useParams()
	const { data, isSuccess, dataUpdatedAt } = useDocumentGet(id as string)
	const { mutate, isPending } = useDocumentUpdate(id as string)

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		const form = event.currentTarget
		event.preventDefault()
		mutate(new FormData(form))
	}

	if (!isSuccess) return null

	return (
		<ReservationDocumentForm
			key={dataUpdatedAt}
			onSubmit={onSubmit}
			isPending={isPending}
			data={data}
		/>
	)
}
